exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.allocation-detail[data-v-4f3d2501] {\n    padding: 10px 20px;\n    background: #fafafa;\n}\n", ""]);

// exports
